// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"8dea71b1","222":"7ffe1e05"}[chunkId] + ".chunk.css";
};